<template>
	<div class="counter">
		<p class="label counter__label">Number of Passengers</p>
		<button class="counter__button type--m" @click="decrement" :disabled="count <= min">-</button>
		<input
			type="number"
			class="counter__input"
			:min="min"
			:max="max"
			v-model="count"
			@change="clampValue"
			@keyup="clampValue"
		/>
		<button class="counter__button type--m" @click="increment" :disabled="count >= max">+</button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			count: this.value
		}
	},

	name: "FlytNumberSelector",

	props: {
		min: {
			type: Number,
			default: 1
		},
		max: {
			type: Number,
			default: 99
		},
		value: {
			type: [Number, String]
		}
	},

	methods: {
		clampValue(evt) {
			let input = parseInt(evt.target.value, 10)
			if (input > this.max) this.count = this.max
			this.update()
		},

		increment() {
			if (this.count >= this.max) return
			this.count++
			this.update()
		},

		decrement() {
			if (this.count <= this.min) return
			this.count--
			this.update()
		},

		update() {
			this.$emit("input", this.count)
		}
	}
}
</script>

<style lang="scss" scoped>
.counter {
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
}
.counter__label {
	flex: 1 0 100%;
	margin-bottom: 0.625em;
}
.counter__button {
	background: $colour-gold;
	border: none;
	color: #fff;
	padding: 0;
	width: 3rem;
	&:first-of-type {
		border-radius: 0.25rem 0 0 0.25rem;
	}
	&:last-of-type {
		border-radius: 0 0.25rem 0.25rem 0;
	}
}
.counter__input {
	border-radius: 0;
	text-align: center;
	width: 4rem;
	// Remove spinners on firefox
	-moz-appearance: textfield;
	// Remove spinners on webkit
	&::-webkit-inner-spin-button, 
	&::-webkit-outer-spin-button { 
		-webkit-appearance: none; 
		margin: 0; 
	}
	&:focus {
		background: $colour-stone;
		border: none;
	}
}
</style>